import { ref, computed } from 'vue'
import { 
  getLikeStatus, 
  setLikeStatus, 
  getFavoriteStatus, 
  setFavoriteStatus,
  incrementToyLikes,
  incrementToyFavorites
} from '@/utils/storage'

/**
 * 点赞和收藏管理组合函数
 */
export function useLikes(toyId) {
  const isLiked = ref(getLikeStatus(toyId))
  const isFavorited = ref(getFavoriteStatus(toyId))

  /**
   * 切换点赞状态
   */
  function toggleLike() {
    const wasLiked = isLiked.value
    isLiked.value = !isLiked.value
    setLikeStatus(toyId, isLiked.value)
    
    // 更新统计数据
    if (isLiked.value && !wasLiked) {
      // 从未点赞变为点赞，增加点赞数
      incrementToyLikes(toyId, 1)
    } else if (!isLiked.value && wasLiked) {
      // 从点赞变为未点赞，减少点赞数
      incrementToyLikes(toyId, -1)
    }
  }

  /**
   * 切换收藏状态
   */
  function toggleFavorite() {
    const wasFavorited = isFavorited.value
    isFavorited.value = !isFavorited.value
    setFavoriteStatus(toyId, isFavorited.value)
    
    // 更新统计数据
    if (isFavorited.value && !wasFavorited) {
      // 从未收藏变为收藏，增加收藏数
      incrementToyFavorites(toyId, 1)
    } else if (!isFavorited.value && wasFavorited) {
      // 从收藏变为未收藏，减少收藏数
      incrementToyFavorites(toyId, -1)
    }
  }

  return {
    isLiked,
    isFavorited,
    toggleLike,
    toggleFavorite
  }
}
